import { FIELDS_MAPPING } from './formErrorConstants';

export function translateFormErrors(errors) {
  let formErrors = errors;
  formErrors = formErrors.filter((e) => e.field !== 'shipping_address');
  formErrors = formErrors.map((e) => {
    e.field = FIELDS_MAPPING[e.field] || e.field;
    return e;
  });

  return formErrors;
}
